export enum SignUpTypes {
    Unknown = 0,
    Affiliate = 1,
    Enterprise = 2,
    TravelAgent = 3, // Deprecated
    Corporate = 4,
    Ambassador = 5,
}